module.exports = __webpack_public_path__ + "img/mit-top-techs.f16cc007.svg";